export default {
  path: '/500',
  name: '500',
  component: () => import('@/views/errors/500.vue').then((m) => m.default),
};
